import React from "react";
import { gravatar, totalBasket, vendorPath } from "../../helpers";
import { ImgIcon } from "../../assets";
import { useLocation, useHistory, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import BasketIcon from "../../assets/BasketIcon";
import ShopIcon from "../../assets/ShopIcon";
import Chevron from "../../assets/Chevron";

export default function UnderPanel() {

	const {
		session: { user },
		vendor,
		basket
	} = useSelector(state => ({
		session: state.session,
		vendor: state.vendor,
		basket: state.basket
	}));

	const { pathname } = useLocation();
	const history = useHistory();
	const [, basketTotal] = totalBasket(basket, vendor);

	const onBasket = /basket$/.test(pathname);

	const onBrand = {
		backgroundColor: vendor.featureColor1 || "#CE003B",
		color: vendor.featureColor2 || "#FFFFFF",
	}

	return <div className="lower-panel" >
		<ImgIcon
			className="user"
			src={user.picture || gravatar(user.email)}
			size={50}
			bg={"#000000"}
			onClick={e => {
				history.push("/me");
			}}
		/>
		<NavLink
			to={vendorPath(vendor.slug)}
			exact
			className="shop v-middle"
			style={!onBasket ? onBrand : {}}
		>
			<ShopIcon
				size={50}
				color={!onBasket ? onBrand.color : "#ffffff"}
				style={{ padding: 11 }}
			/>
			<button className="back v-middle">
				<div className="overlay" />
				<Chevron
					size={20}
					color={!onBasket ? onBrand.color : "#ffffff"}
					direction="left"
				/>
				<span>Back</span>
			</button>
		</NavLink>
		<NavLink
			to={`${vendorPath(vendor.slug)}/basket`}
			className="basket v-middle"
			style={onBasket ? onBrand : {}}
		>
			<BasketIcon size={50} color={onBasket ? onBrand.color : "#ffffff"} />
			<div className="total featureFont">
				£{(basketTotal / 100).toFixed(2)}
			</div>
			<button className="continue v-middle">
				<div className="overlay" />
				{basket.items.length ? <>
					{onBasket ?
						(
							<span> </span>
						) : <>
							<span>{!onBasket ? "Continue" : " "}</span>
							<Chevron
								size={20}
								color={onBasket ? onBrand.color : "#ffffff"}
								direction="right"
							/>
						</>
					}
				</> : <span style={{ paddingRight: 10 }}>Add Items</span>}
			</button>
		</NavLink >
	</div >
}